import 'bootstrap/dist/css/bootstrap.min.css'
import { Carousel, Row } from 'react-bootstrap';
import React from 'react';

const WorksCarousel = (props) =>{

    return(
        <Row xs={1} md={4} style={{margin: '20px', marginBottom: '50px', marginTop: '50px'}}>
        
        <Carousel fade style={{height: '400px', width: '400px', marginBottom: '50px'}}>
        <Carousel.Item>
          <img style={{height: '400px', width: '400px', marginBottom: '50px'}}
            src="https://firebasestorage.googleapis.com/v0/b/eligman-a9763.appspot.com/o/works%2Fwork1%2Ffront_before.jpg?alt=media&token=2461b27e-d628-4781-8b79-c65af7906542"
            alt="First slide"
          />
          <Carousel.Caption>
            <h3>לפני</h3>
            <p>שלמה בן יוסף 4 אשדוד</p>
          </Carousel.Caption>
        </Carousel.Item>
  
        <Carousel.Item>
          <img style={{height: '400px', width: '400px', marginBottom: '50px'}}
            src="https://firebasestorage.googleapis.com/v0/b/eligman-a9763.appspot.com/o/works%2Fwork1%2Ffront_after.jpg?alt=media&token=3cdabae1-1d51-445a-b6a4-44cf57bf16fb"
            alt="Second slide"
          />
          <Carousel.Caption>
            <h3>אחרי</h3>
            <p>שלמה בן יוסף 4 אשדוד</p>
          </Carousel.Caption>
        </Carousel.Item>
        </Carousel>
  
    <Carousel fade style={{height: '400px', width: '400px', marginBottom: '50px'}}>
        <Carousel.Item>
          <img style={{height: '400px', width: '400px'}}
            src="https://firebasestorage.googleapis.com/v0/b/eligman-a9763.appspot.com/o/works%2Fwork2%2Fbefore.jpg?alt=media&token=54cdacd5-cd9a-4e29-83b2-fd1fac5a6184"
            alt="First slide"
          />
          <Carousel.Caption>
            <h3>לפני</h3>
            <p>אבא הלל 13 אשדוד</p>
          </Carousel.Caption>
        </Carousel.Item>
  
        <Carousel.Item>
          <img style={{height: '400px', width: '400px', marginBottom: '50px'}}
            src="https://firebasestorage.googleapis.com/v0/b/eligman-a9763.appspot.com/o/works%2Fwork2%2Fafter.jpg?alt=media&token=41c27e34-7680-4007-8702-2f692cb7b033"
            alt="Second slide"
          />
          <Carousel.Caption>
            <h3>אחרי</h3>
            <p>אבא הלל 13 אשדוד</p>
          </Carousel.Caption>
        </Carousel.Item>
         </Carousel>

         <Carousel fade style={{height: '400px', width: '400px', marginBottom: '50px'}}>
        <Carousel.Item>
          <img style={{height: '400px', width: '400px', marginBottom: '50px'}}
            src="https://firebasestorage.googleapis.com/v0/b/eligman-a9763.appspot.com/o/works%2Fwork3%2FLabor%2011%20Ashdod_EXT_01_DL.jpg?alt=media&token=7f2d0223-893e-484c-9649-ef82e8c01755"
            alt="First slide"
          />
          <Carousel.Caption>
          <p>העמל 11 אשדוד</p>
          </Carousel.Caption>
        </Carousel.Item>
  
        <Carousel.Item>
          <img style={{height: '400px', width: '400px', marginBottom: '50px'}}
            src="https://firebasestorage.googleapis.com/v0/b/eligman-a9763.appspot.com/o/works%2Fwork3%2FLabor%2011%20Ashdod_EXT_05_PTM.jpg?alt=media&token=7f85d78f-5fdb-4ddf-bdac-ec625d922565"
            alt="Second slide"
          />
          <Carousel.Caption>
            <p>העמל 11 אשדוד</p>
          </Carousel.Caption>
        </Carousel.Item>
        </Carousel>

        <Carousel fade style={{height: '400px', width: '400px', marginBottom: '50px'}}>
        <Carousel.Item>
          <img style={{height: '400px', width: '400px', marginBottom: '50px'}}
            src="https://firebasestorage.googleapis.com/v0/b/eligman-a9763.appspot.com/o/works%2Fwork4%2FPasted%20Image%20%231%20111739AE.png?alt=media&token=171f809d-8736-4dc7-9a3f-2d5ec2c51bb7"
            alt="First slide"
          />
          <Carousel.Caption>
            <p>בית העולה אשדוד רובע י"ג</p>
          </Carousel.Caption>
        </Carousel.Item>

        <Carousel.Item>
          <img style={{height: '400px', width: '400px', marginBottom: '50px'}}
            src="https://firebasestorage.googleapis.com/v0/b/eligman-a9763.appspot.com/o/works%2Fwork4%2FPasted%20Image%20%232%2072AE3580.png?alt=media&token=3a45d1d5-2db7-486d-9120-72ef49d12482"
            alt="Second slide"
          />
          <Carousel.Caption>
            <p>בית העולה אשדוד רובע י"ג</p>
          </Carousel.Caption>
        </Carousel.Item>

        <Carousel.Item>
          <img style={{height: '400px', width: '400px', marginBottom: '50px'}}
            src="https://firebasestorage.googleapis.com/v0/b/eligman-a9763.appspot.com/o/works%2Fwork4%2FPasted%20Image%20%235%20ABEEC3C6.png?alt=media&token=354defc7-443b-4637-86e4-3f69b1778b72"
            alt="third slide"
          />
          <Carousel.Caption>
            <p>בית העולה אשדוד רובע י"ג</p>
          </Carousel.Caption>
        </Carousel.Item>
        </Carousel>

        <Carousel fade style={{height: '400px', width: '400px', marginBottom: '50px'}}>
        <Carousel.Item>
          <img style={{height: '400px', width: '400px', marginBottom: '50px'}}
            src="https://firebasestorage.googleapis.com/v0/b/eligman-a9763.appspot.com/o/works%2Fwork5%2F1-8-CAMERA.png?alt=media&token=0c6fefab-17c7-4742-9751-51a7f78dac20"
            alt="First slide"
          />
          <Carousel.Caption>
          <p>חתיבת הנגב 22 אשדוד</p>
          </Carousel.Caption>
        </Carousel.Item>
  
        <Carousel.Item>
          <img style={{height: '400px', width: '400px', marginBottom: '50px'}}
            src="https://firebasestorage.googleapis.com/v0/b/eligman-a9763.appspot.com/o/works%2Fwork5%2F1-7-CAMERA.png?alt=media&token=6e4222f5-ea45-473c-9407-d36b98cc80b3"
            alt="Second slide"
          />
          <Carousel.Caption>
            <p>חתיבת הנגב 22 אשדוד</p>
          </Carousel.Caption>
        </Carousel.Item>
        </Carousel>
         </Row>
        );
}

export default WorksCarousel;